import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../../services/api';
import '../../styles/AdminStyles.css';

function AdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if admin is already logged in
    const admin = localStorage.getItem('admin');
    const adminToken = localStorage.getItem('adminToken');
    if (admin && adminToken) {
      navigate('/admin/dashboard');
    }

    // If regular user is logged in, redirect to user profile
    const user = localStorage.getItem('user');
    const userToken = localStorage.getItem('token');
    if (user && userToken) {
      navigate('/profile');
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await authAPI.loginAdmin(username, password);

      if (response.success) {
        // Admin data is already stored by authAPI.loginAdmin()
        // Redirect to dashboard
        navigate('/admin/dashboard');
      } else {
        // Clear any stale data if login was not successful
        localStorage.removeItem('admin');
        localStorage.removeItem('adminToken');
        setError('שגיאה בהתחברות. אנא בדוק את פרטי ההתחברות.');
      }
    } catch (err) {
      // Clear localStorage on failed login
      localStorage.removeItem('admin');
      localStorage.removeItem('adminToken');
      setError(err.response?.data?.error || 'שגיאה בהתחברות. אנא נסה שוב.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-box">
        <div className="admin-login-header">
          <h1>🏋️ Pilates House</h1>
          <h2>פאנל ניהול</h2>
        </div>

        <form onSubmit={handleSubmit} className="admin-login-form">
          {error && (
            <div className="admin-error-message">
              {error}
            </div>
          )}

          <div className="admin-form-group">
            <label>שם משתמש</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="הזן שם משתמש"
              required
              disabled={loading}
            />
          </div>

          <div className="admin-form-group">
            <label>סיסמה</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="הזן סיסמה"
              required
              disabled={loading}
            />
          </div>

          <button
            type="submit"
            className="admin-login-button"
            disabled={loading}
          >
            {loading ? 'מתחבר...' : 'התחבר'}
          </button>
        </form>

        <div className="admin-login-footer">
          <p>
            <a href="/">חזרה לדף הבית</a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default AdminLogin;
